import React, { Suspense, useEffect, useState, lazy, useRef } from "react";
import Loader from "./components/UI/Loader/Loader";
import { withErrorBoundary } from "./hoc/ErrorBoundary/ErrorBoundary";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import { AbilityContext } from "./config/ability-context";
import ability from "./config/ability";
import { setAccessRestrictedCallback, setSessionExpiredCallback } from "./api/index";
import AppLayout from "./hoc/AppLayout/AppLayout";
import { useSelector, useDispatch } from "react-redux";
import { adviceAlert, errorRetryAlert } from "./utils/alerts";
import { useTranslation } from "react-i18next";
import { ROUTE_HOME } from "./constants/routes";
import i18next from "i18next";
import GenerallUI from "./components/UI/General/GenerallUI";
import SessionExpired from "./components/SessionExpired/SessionExpired";
import { getAuthUser, userGoLandingPage, userLogout } from "./store/actions/user";
import { lightTheme, darkTheme } from "./css/theme";
import CssBaseline from "@mui/material/CssBaseline";
import componentLoader from "./utils/lazyUtils";
import packageJson from "../package.json";
import { StyledEngineProvider, ThemeProvider } from "@mui/material";
import { setAccessRestricted, setAppLoading, setSessionExpired } from "./store/reducers/app";
import { hideError } from "./utils/utils";
import LoginPage from "./components/LoginPage/LoginPage";
import queryString from "query-string";

const attemptsLeft = 5;

function App() {
  const { t, i18n } = useTranslation();
  const user = useSelector((state) => state.user.user);
  // const { appLoading } = useSelector((state) => state.app);
  const sessionExpired = useSelector((state) => state.app.sessionExpired);

  const dispatch = useDispatch();
  const firstLoadUser = useRef(true);
  const darkMode = useSelector((state) => state.app.darkMode);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    //comprobamos la versión del paquete por si hay una nueva limpiar la cache
    let version = localStorage.getItem("version");
    if (version != packageJson.version) {
      if ("caches" in window) {
        caches.keys().then((names) => {
          // Delete all the cache files
          names.forEach((name) => {
            caches.delete(name);
          });
        });

        // Makes sure the page reloads. Changes are only visible after you refresh.
        window.location.reload(true);
      }

      localStorage.clear();
      localStorage.setItem("version", packageJson.version);
    } else {
      init();
      window.addEventListener("error", hideError);
    }

    // const lang =
    //   i18next.languages && i18next.languages.length
    //     ? i18next.languages[0] === "en"
    //       ? "en-gb"
    //       : i18next.languages[0]
    //     : "es";
    // console.log("i18next.languages: ", i18next.languages);

    return () => {
      window.removeEventListener("error", hideError);
    };
  }, []);

  const init = () => {
    setSessionExpiredCallback(sessionExpiredHandler);
    setAccessRestrictedCallback(accessRestrictedHandler);
    fetchUser();
  };

  useEffect(() => {
    if (user && firstLoadUser.current) {
      firstLoadUser.current = false;
    }
  }, [user]);

  const fetchUser = () => {
    dispatch(setAppLoading(true));
    getAuthUser(dispatch)
      .then((user) => {
        if (user) {
          if (user.getLang()) {
            i18n.changeLanguage(user.getLang());
            document.documentElement.lang =
              user.getLang() === "en" || user.getLang() === "en-gb" ? "en" : user.getLang() === "it" ? "it" : "es";
          }
          //comprobamos si viene algún error en la url para mostrarlo

          const urlParsed = queryString.parse(window.location.search);
          if (urlParsed.error) {
            adviceAlert({ t: t, text: urlParsed.error });
          }
        } else {
          dispatch(setAppLoading(false));
        }
      })
      .catch((e) => {
        console.error("ERROR FETCH USER", e);
        // sessionExpiredHandler();
        errorRetryAlert({ t: t, onRetry: fetchUser });
      })
      .finally(() => {
        dispatch(setAppLoading(false));
        setLoading(false);
      });
  };

  const sessionExpiredHandler = () => {
    console.log("session expired");
    dispatch(setAppLoading(false));
    dispatch(setSessionExpired(true));
  };
  const accessRestrictedHandler = (exception) => {
    dispatch(setAccessRestricted(exception));
  };

  const DashboardContainer = lazy(() => componentLoader(() => import("./containers/DashboardContainer"), attemptsLeft));

  const onLogoutHandler = () => {
    userLogout(dispatch);
  };

  return (
    <AbilityContext.Provider value={ability(user)}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={darkMode ? darkTheme : lightTheme}>
          <CssBaseline />
          <Suspense fallback={<Loader />}>
            <GenerallUI />
            {user && (
              <AppLayout>
                <Routes>
                  <Route path={ROUTE_HOME} element={<DashboardContainer />} />
                </Routes>
              </AppLayout>
            )}
            {/* {sessionExpired && <SessionExpired onLogout={onLogoutHandler} />} */}
            {!user && !loading && <LoginPage />}
          </Suspense>
        </ThemeProvider>
      </StyledEngineProvider>
    </AbilityContext.Provider>
  );
}

export default withErrorBoundary(App);
